import gql from 'graphql-tag';

export const candidateTagsQuery = gql`
  query candidateTags($accountId: ID!) {
    account(accountId: $accountId) {
      id
      candidateTags {
        id
        name
        icon
        description
        color
      }
    }
  }
`;
